module.exports = __webpack_public_path__ + "media/savings_calculator/loan_btn-debd6b6e.png";